var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"leave-page-details-modal","title":_vm.title,"title-class":"h4 font-weight-bold","lazy":"","size":"lg","hide-footer":""}},[_c('div',{staticClass:"d-flex px-3 pb-3 flex-column"},[_c('LeavePageDetailsEditForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }